/**
 * 미디어 중앙에 얹히는 재생 배지.
 * 프로토타입에서는 장식용이었으므로 pointer-events를 막아 클릭을 방해하지 않는다.
 * 실제 재생을 붙일 때는 onClick을 받도록 확장하면 된다.
 */
export function PlayBadge({ size = 62 }: { size?: number }) {
  const triangle = Math.round(size * 0.26)
  const wing = Math.round(size * 0.18)

  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <span
        className="flex items-center justify-center rounded-full shadow-play"
        style={{ width: size, height: size, background: 'var(--accent)' }}
        aria-hidden="true"
      >
        <span
          style={{
            borderLeft: `${triangle}px solid #fff`,
            borderTop: `${wing}px solid transparent`,
            borderBottom: `${wing}px solid transparent`,
            marginLeft: Math.round(size * 0.08),
          }}
        />
      </span>
    </div>
  )
}
